module.exports = __webpack_public_path__ + "images/emoji/earth_africa.2b465a3cfd16d7368510.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/earth_africa.png
// module id = 45Ft
// module chunks = 24